import { Header } from "./Header"
import { Navigation } from "./Navigation"

export const Section = {
  observer: () => {
    const getAllSections = document.querySelectorAll('[data-section]')
		
    const observer = new IntersectionObserver(entries => {
      	
			entries.forEach( entry => {

				if(entry.isIntersecting) {
					Navigation.currentLink(entry.target.id)
				}

      })
    }, { threshold: [0.50, 1]})

    getAllSections.forEach(section => {
      observer.observe(section)
    })		

		const observerHero = new IntersectionObserver(entry => {
			const [IntersectionObserverEntry] = entry
 
			Header.fixed(!IntersectionObserverEntry.isIntersecting)
		}, { threshold: 0 })

		const hero = document.querySelector('#hero')
		observerHero.observe(hero)
  },
  current: (current) => {
    if(!current) return    
  },
  init: () => {
    Section.observer()
  }
}

